// @ts-nocheck
import styled from 'styled-components';
import { getTheme } from 'settings/theme';
import type { StatelessFunctionalComponent } from 'react';

const {
  palette: { greyscale, noodle },
} = getTheme();
const CheckGroupWrapper: StatelessFunctionalComponent<any> = styled.div`
  :focus {
    outline: none;
  }

  .check-container {
    cursor: pointer;
    display: block;
    margin-bottom: 1.4rem;
    padding-left: 3rem;
    position: relative;
    user-select: none;
  }

  .checkmark,
  .active-check {
    background-color: ${greyscale.white};
    border: ${greyscale.smoke} 2px solid;
    border-radius: 0.4rem;
    height: 1.8rem;
    left: 0;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 1.8rem;
  }

  .check-container .active-check {
    border: ${greyscale.iron} 2px solid;
  }

  .checkmark:after,
  .active-check:after {
    content: '';
    display: none;
    position: absolute;
  }

  .check-container .active-check:after {
    display: block;
  }

  .check-container .active-check:after {
    border: solid ${noodle.secondary};
    border-width: 0 2px 2px 0;
    height: 1rem;
    left: 0.5rem;
    top: 0.1rem;
    transform: rotate(45deg);
    width: 0.5rem;
  }
`;
export default CheckGroupWrapper;
